import { Component, OnInit } from '@angular/core';
import { LanguageModalComponent } from 'app/public/language-modal/language-modal.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'ma-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  private dialogRef: MatDialogRef<any, any>;

  constructor(
    public dialog: MatDialog,
    public language: LanguageService,
    ) {
  }

  ngOnInit(): void {

  }

  go() {
    window.scrollTo(0, 0);
  }

  openLanguageModal(): void {
    if (this.dialogRef == undefined) {
      this.dialogRef = this.dialog.open(LanguageModalComponent, {});

      this.dialogRef.afterClosed().subscribe(result => {
        this.dialogRef = result;
      });
    } else {
      this.dialog.closeAll();
      this.dialogRef = undefined;
    }
  }

}
